type TokenEncoder = {
  encode: (value: string) => number[];
};

let encoderPromise: Promise<TokenEncoder> | null = null;
let lastTokenizedValue = '';
let lastTokenizedCount = 0;

async function getTokenEncoder() {
  if (!encoderPromise) {
    encoderPromise = Promise.all([import('js-tiktoken/lite'), import('js-tiktoken/ranks/cl100k_base')]).then(([{ Tiktoken }, { default: cl100kBase }]) => new Tiktoken(cl100kBase));
  }
  return encoderPromise;
}

export async function countTextTokens(value: string) {
  if (value === lastTokenizedValue) return lastTokenizedCount;
  const encoder = await getTokenEncoder();
  const count = encoder.encode(value).length;
  lastTokenizedValue = value;
  lastTokenizedCount = count;
  return count;
}
